import * as React from "react";

import { IDayCell_MonthMobile, IDayCellSlot_MonthMobile } from "../../../classes/dayCell_MonthMobile";
import { IText } from "../../../classes/Text";

import { MonthListEventAnchor } from "../Common/MonthListEventAnchor";

import * as dates from "../../../reducers/changeTimePeriod";

export interface IMonthListEventsProps {
    dayCell: IDayCell_MonthMobile;
    text: IText;
    contextId: number;
    selectedDate: Date;
    pageId: number;
    parentId: number;
    portalId: number;
    portletInstanceId: number;
    todaysDate: Date;
    userDateFormat: string;
    viewMode: string;
    onStartAjaxCall: (event: any) => any;
    onSetCurrentDate: (event: any) => any;
    onSetEventId: (event: any) => any;
    onSetEventScreenMode: (eventScreenMode: string) => any;
    onSetiCalStartDate: (event: any) => any;
    onSetDisplayedEventLocalStartDate: (localStartDate: Date) => any;
    onSetDisplayedEventLocalEndDate: (localEndDate: Date) => any;
    onSetViewMode: (event: any) => any;
}

const getEventsJSX = (props: IMonthListEventsProps) => {
    const events: JSX.Element[] = [];

    const setToDailyViewModeAndSetCurrentDateToThisDate = (e) => {
        props.onSetCurrentDate(e);
        props.onSetViewMode(e);
    };

    // Sort events by the time of day only (not by date+time that events start, which is the default order).
    const slotsData = props.dayCell.slots; // Create shallow copy of array.
    slotsData.sort((a, b) => {
        return dates.compareTimeOfDay(a.event.localStartDate, b.event.localStartDate, a.event.name, b.event.name);
    });

    for (const slot of slotsData) {
        events.push(
            <MonthListEventAnchor
                event={slot.event}
                allDayText={props.text.eventViews.allDay}
                eventText={props.text.eventViews.event}
                toText={props.text.eventViews.to}
                key={slot.slotNumber}
                contextId={props.contextId}
                selectedDate={props.selectedDate}
                pageId={props.pageId}
                parentId={props.parentId}
                portalId={props.portalId}
                portletInstanceId={props.portletInstanceId}
                todaysDate={props.todaysDate}
                thisDate={props.dayCell.date}
                userDateFormat={props.userDateFormat}
                viewMode={props.viewMode}
                useSingleDayDescription={false}
                onStartAjaxCall={props.onStartAjaxCall}
                onSetEventId={props.onSetEventId}
                onSetEventScreenMode={props.onSetEventScreenMode}
                onSetiCalStartDate={props.onSetiCalStartDate}
                onSetDisplayedEventLocalStartDate={props.onSetDisplayedEventLocalStartDate}
                onSetDisplayedEventLocalEndDate={props.onSetDisplayedEventLocalEndDate}
            />,
        );
    }

    events.push(
        <li className="CAL-EV-Item CAL-EV-plus" key={100}>
            <a href="#!" onClick={setToDailyViewModeAndSetCurrentDateToThisDate} data-value="DAILYLIST" data-date={props.dayCell.date}>+{props.dayCell.totalNumberEvents}</a>
        </li>,
    );

    return events;
};

export const MonthListEvents = (props: IMonthListEventsProps) => {
    if (props.dayCell.totalNumberEvents > 0) {
        const events = getEventsJSX(props);
        return (
            <ul className="CAL-V-MV-events">
                {events}
            </ul>
        );
    } else {
        return (
            <span className="offScreen">{props.text.eventViews.noEventsOnThisDay}</span>
        );
    }
};
